<template>
  <div class="page-main">
    <div class="myHead">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager/storageTank' }">储罐区域</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.params.id ? '编辑' : '新增'}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="myBody">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px"
        size="small" style="width: 70%; margin: auto">
        <el-form-item label="储罐区编号" prop="serialNum">
          <el-input v-model="ruleForm.serialNum" />
        </el-form-item>
        <el-form-item label="储罐区名称" prop="name">
          <el-input v-model="ruleForm.name" />
        </el-form-item>
        <el-form-item label="在厂区的位置" prop="locationForFactory">
          <el-input v-model="ruleForm.locationForFactory" />
        </el-form-item>
        <el-form-item label="所处环境功能区" prop="environmentFunction">
          <el-input v-model="ruleForm.environmentFunction" />
        </el-form-item>
        <el-form-item label="储罐区面积" prop="acreage">
          <el-input v-model="ruleForm.acreage" type="number">
            <template slot="append">平方米</template>
          </el-input>
        </el-form-item>
        <el-form-item label="有无围堰" prop="cofferdam">
          <el-radio-group v-model="ruleForm.cofferdam" size="small">
            <el-radio-button :label="0">无</el-radio-button>
            <el-radio-button :label="1">有</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="围堰所围面积">
          <el-input v-model="ruleForm.cofferdamAcreage" type="number">
            <template slot="append">平方米</template>
          </el-input>
        </el-form-item>
        <el-form-item label="储罐个数" prop="storageTankNum">
          <el-input v-model="ruleForm.storageTankNum" type="number">
            <template slot="append">个</template>
          </el-input>
        </el-form-item>
        <el-form-item label="储存物质" prop="storageMatter">
          <el-input v-model="ruleForm.storageMatter" />
        </el-form-item>
        <el-form-item label="储罐区总容积" prop="grossCapacity">
          <el-input v-model="ruleForm.grossCapacity" type="number">
            <template slot="append">m³</template>
          </el-input>
        </el-form-item>
        <el-form-item label="常规储存量" prop="normalStorageVolume">
          <el-input v-model="ruleForm.normalStorageVolume" type="number">
            <template slot="append">m³</template>
          </el-input>
        </el-form-item>
        <el-form-item label="两罐间最小间距" prop="minimumDistanceForTanks">
          <el-input v-model="ruleForm.minimumDistanceForTanks">
            <template slot="append">米</template>
          </el-input>
        </el-form-item>
        <el-form-item label="有无消防通道" prop="fireFightingAccess">
          <el-radio-group v-model="ruleForm.fireFightingAccess" size="small">
            <el-radio-button label="无"></el-radio-button>
            <el-radio-button label="有"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="装卸方式" prop="handlingMode">
          <el-input v-model="ruleForm.handlingMode" />
        </el-form-item>
        <el-form-item label="装卸危险化学品种类" prop="handlingDangerousChemicalType">
          <el-input v-model="ruleForm.handlingDangerousChemicalType" />
        </el-form-item>
        <el-form-item label="现场照片">
          <el-upload
            class="avatar-uploader"
            action="/v1/trainMaterials/uploadFile"
            :show-file-list="false"
            :on-success="handleAvatarSuccess">
            <img v-if="ruleForm.sitePhotos" :src="host + ruleForm.sitePhotos" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
<!--        <el-form-item label-width="0">
          <el-col :span="12">
            <el-form-item label="经度" prop="longitude">
              <el-input v-model="ruleForm.longitude" type="number">
                <template slot="append">度</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度" prop="latitude">
              <el-input v-model="ruleForm.latitude" type="number">
                <template slot="append">度</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>-->
        <el-form-item label="备注">
          <el-input v-model="ruleForm.remarks" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item class="form-item-button">
          <el-button type="primary" @click="submit">保存</el-button>
          <el-button type="danger" @click="$router.back()">返回</el-button>
        </el-form-item>
      </el-form>  
    </div>
  </div>
</template>

<script>
  import { storageTankAdd, storageTankEdit } from "@/api/majorHazard"
  export default {
    name: "warehouseArea",
    data() {
      return {
        ruleForm: {},
        rules: {
          serialNum: [{ required: true, message: '请输入' }],
          name: [{ required: true, message: '请输入' }],
          locationForFactory: [{ required: true, message: '请输入' }],
          environmentFunction: [{ required: true, message: '请输入' }],
          acreage: [{ required: true, message: '请输入' }],
          cofferdam: [{ required: true, message: '请选择' }],
          storageTankNum: [{ required: true, message: '请输入' }],
          storageMatter: [{ required: true, message: '请输入' }],
          grossCapacity: [{ required: true, message: '请输入' }],
          normalStorageVolume: [{ required: true, message: '请输入' }],
          minimumDistanceForTanks: [{ required: true, message: '请输入' }],
          fireFightingAccess: [{ required: true, message: '请选择' }],
          handlingMode: [{ required: true, message: '请输入' }],
          handlingDangerousChemicalType: [{ required: true, message: '请输入' }],
          longitude: [{ required: true, message: '请输入' }],
          latitude: [{ required: true, message: '请输入' }],
        },
      }
    },
    created() {
      if(this.$route.params.id) {
        this.ruleForm = this.$route.params
      }
    },
    methods: {
      // 上传的事件
      handleAvatarSuccess(res, file) {
        this.$set(this.ruleForm, 'sitePhotos', res.data)
      },
      // 保存
      submit() {
        this.$refs['ruleForm'].validate((valid) => {
          if(valid) {
            // 编辑
            if(this.$route.params.id) {
              storageTankEdit(this.ruleForm).then(res => {
                this.$message.success('保存成功')
                this.$router.push('/processManager/storageTank')
              })
            } else {
              // 新增
              storageTankAdd(this.ruleForm).then(res => {
                this.$message.success('保存成功')
                this.$router.push('/processManager/storageTank')
              })
            }
          }else{
            return false
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .page-main {
    height: 100%;
  }
  .myHead {
    position: absolute;
    top: 0;
    left: 250px;
    width: calc(100% - 250px);
    padding: 20px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .myBody {
    background-color: #ffffff;
    height: 100%;
    overflow: scroll;
    padding: 20px;
    .body-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .search-input {
        .search-btn {
          background-color: #409EFF;
          color: #fff;
          /*border-color: #409EFF;*/
        }
      }
    }
    .body-main {
      margin-top: 20px;
    }
    .el-form-item {
      .item-btn {
        display: flex;
        align-items: center;
        .btn {
          margin-left: 20px;
        }
      }
      .el-select {
        width: 100%;
      }
    }
    .form-item-button {
      display: flex;
      justify-content: center;
    }
  }
</style>
